<template>
    <div style="padding-left:10px">
        <h3 style="text-align:center;font-size: 18px">{{detailData.MsgTitle}}</h3>
        <div style="margin-top: 10px;">
            <span v-for="(i,ind) in detailData.Tags?detailData.Tags.split(','):[]" 
            :key="ind" class="tags">{{i}}</span>
        </div>
        <div style="color:#333">
            <div style="margin-top:10px">
                <span style="margin-right:20px">发布时间：{{detailData.BeginTime}}</span> 
                <span>发布人：{{detailData.AddUser}}</span>
            </div>
            <div v-if="type=='course'" style="margin-top:10px">
                <span>网课类型：{{detailData.FileType}}</span>
                <div v-if="detailData.CoverFiles">
                    <span class="conent_left">封面：</span>
                    <div style="margin-left:70px;margin-top:10px">
                        <el-carousel height="180px" style="width:70%">
                            <el-carousel-item v-for="(item,ind) in detailData.CoverFiles" :key="ind">
                               <img style="width:100%" :src="hostUrl+item.FileLogoURL" alt="" @click="jump(item,item.FileId)">
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
            <div style="margin-top:5px;line-height:24px">
                <span class="conent_left">
                    <span v-if="type=='course'">网课介绍：</span>
                    <span v-else>公告内容：</span>
                </span>
                <div style="margin-left:70px;" v-html="detailData.MsgBodyURL"></div>
            </div>
            <div>
                <span class="conent_left">附件：</span>
                <div class="Img_box" v-for="(item,index) in detailData.ExtFiles" :key="index" @click="jump(item,item.FileId)">
                    <img class="Img" :src="item.FileLogoURL" alt="">
                    <span>{{item.FileName}}</span>
                </div>
            </div>
        </div>
        <!-- 评论 -->
        <div class="box">
            <div class="box2" v-if="detailData.AllowComments==1">
                <div @click="giveUp(detailData.Id)">
                    <i class="el-icon-thumb icon" :style="{color:(showUp?'#1989fa':'')}"></i>
                    <h4 style="display: inline-block;margin:0;font-size:14px">{{count}}人点赞</h4> 
                </div>
                <div @click="showSheet">
                    <i class="el-icon-chat-dot-square icon"></i></div>
            </div>
            <div v-if="showComment" class="comments">
                <el-input class="msg_box" type="textarea" :rows="3" placeholder="请填写评论" v-model="message"></el-input>
                <el-button @click="confrim(detailData.Id)" class="confrim_btn" size="medium" type="primary">发表</el-button>
                <el-button @click="cancel" class="confrim_btn cancel" size="medium" type="info">取消</el-button>
            </div>
            <div class="detail-item">
                <div v-for="(item,index) in detailData.CommentsUser" 
                    :key="index" style="padding:0 5px;line-height: 24px;">
                    <span style="color:#1989fa">{{item.UserName}}:</span>
                    <span style="color:#333">{{item.Comments}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from "./../../utils/storage"
    import { getBaseUrl,GetDownFileById,ThumbsUp,SendMessage,getFileMsgDetailList } from "../../api/api";

    export default {
        name: "Infomation",
        props:{
          Infomation:Object,
          type:String,
        },
        data() {
            return {
                hostUrl:getBaseUrl(),
                curUser: store.getUserInfo(),
                curMenu: store.getCurMenu(),
                detailData:{},
                showDetail:false,
                showComment:false,
                message:'',
                count:0,
                copyItem:{},
               showUp:false,
            };
        },
        mounted() {
            this.FileMsg()
            console.log(this.type,'type')
        },
        methods: {
            FileMsg(){
                console.log(this.Infomation,'this.Infomation')
                this.copyItem = this.Infomation;
                var querypar={
                    ID :this.Infomation.Id,
                    uid:this.curUser.UserId
                }
                getFileMsgDetailList(querypar).then(res => {
                    if (res.data.Code != 1) this.$message.error(res.data.Message);
                    this.detailData = res.data.Data?res.data.Data[0]:{};
                    this.showDetail = true;
                    if(this.detailData.ThumbsUpUser){
                        this.count = this.detailData.ThumbsUpUser.length;
                        this.detailData.ThumbsUpUser.forEach(i => {
                            console.log(i.UserId,this.curUser.UserId,'UserId' )
                            if(i.UserId == this.curUser.UserId){
                                this.showUp = true;
                            }else{
                                this.showUp = false;
                            }
                        });
                    }else{
                        this.count = 0;
                        this.showUp = false;
                    }
                })
            },
            jump(item,FileId){
                var params = {
                    'UserId': this.curUser.UserId,
                    'fileId': FileId
                }
                GetDownFileById(params).then(res => {
                    if (res.data.Code != 1) this.$message.error(res.data.Message);
                    var data;
                    if(res.data.Data.indexOf('wwo.wps.cn')>-1){
                        sessionStorage.wpsUrl =res.data.Data;
                        sessionStorage.token = store.getToken();
                        data = this.$router.resolve({name: 'viewFile'});
                    }
                    else{ 
                        sessionStorage.fileURL =this.hostUrl+res.data.Data;
                        data = this.$router.resolve({name: 'vFile'});
                    }
                    // const data = this.$router.resolve({name: 'viewFile'});
                    var obj = window.open(data.href);
                    setTimeout(function(){ obj.document.title = item.FileName; }, 100);
                });
            },
            giveUp(Id){
                var params = {
                    'ID':Id,
                    'UserId':this.curUser.UserId,
                }
                ThumbsUp(params).then(res=>{
                    if (res.data.Code != 1) this.$message.error(res.data.Message);
                    else{
                        this.FileMsg(this.copyItem);
                        this.$message.success(res.data.Data);
                    }
                })
            },
            // 评论
            showSheet(){
                this.showComment = true;
                this.message = '';
            },
            confrim(Id){
                var params = {
                    'ID': Id,
                    'UserId':this.curUser.UserId,
                    'Comments':this.message
                }
                SendMessage(params).then(res => {
                    if (res.data.Code != 1) this.$message.error(res.data.Message);
                    else{
                        this.$message.success(res.data.Data);
                        this.FileMsg(this.copyItem);
                        this.showComment = false;
                        this.message = '';
                    }
                });
            },
            cancel(){
                this.showComment = false;
                this.message = '';
            }
        },
        watch: {
            Infomation:function() {
                this.FileMsg()
                
            }    
        }

    };
</script>

<style scoped>
    /* @import "../assets/css/home.css"; */
    .title{
        display: inline-block;
        width: 65%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-decoration:underline
    }
    .tags{
        margin-left: 10px;
        display: inline-block;
        padding: 5px 14px;
        border-radius: 16px;
        color: #fff;
        font-size: 12px;
        background: #1989fa;
    }
    .conent_left{
        float: left;
        width:70px;
        text-align:right
    }
    .Img_box{
        margin-left:70px;
        margin-top: 15px;
        padding-left: 10px;
    }
    .Img_box:first-of-type{
        padding-top: 15px;
        box-sizing: border-box;
    }
    .Img_box img{
        vertical-align: bottom;
    }
    .Img_box span{
        display: inline-block;
        width: 70%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .box{
        margin-top: 15px;
        position: relative;
    }
    .box2{
        display: flex;
        justify-content: space-between;
        /* background: antiquewhite; */
        line-height: 24px;
        padding: 3px 8px;
        box-sizing: border-box;
    }
    .icon{
        font-size: 20px;
        /* vertical-align: middle; */
    }
    .comments{
        position: relative;
        background: #fff;
        width: 96%;
        left: 0;
        top: 0px;
        height: 140px;
        padding: 0 10px;
    }
    .msg_box{
        margin-top: 10px;
    }
    .confrim_btn{
        margin-top: 15px;
    }
    .cancel{
        margin-left: 40px;
    }
    .detail-item{
        max-height: 180px;
        overflow: auto;
        margin-top: 3px;
        width: 98%;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .info_l2{
        align-items: normal; 
        padding-top: 36px;
        /* background: aqua; */
        box-sizing: border-box;
    }

</style>


// WEBPACK FOOTER //
// src/components/public/Infomation.vue